export const SIGNED_URL_API = "https://xwjx8kns56.execute-api.us-east-1.amazonaws.com/signed-url";
